import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MultiSelectCheckBoxService {
  confirmEditInfo:BehaviorSubject<ConfirmEditInfo> = new BehaviorSubject<ConfirmEditInfo>(null);
  
  constructor() { }

  setConfirmEditData(confirmEditData:any,rowIndex:number):void{
    console.log({ConfirmEditData:confirmEditData,RowIndex:rowIndex})
    let confirmEditInfo = {confirmEditData:confirmEditData,rowIndex:rowIndex}
    this.confirmEditInfo.next(confirmEditInfo)
  }

  getConfirmEditData():Observable<ConfirmEditInfo>{
    return this.confirmEditInfo.asObservable();
  }

  checkIsSame(confirmEditData):boolean{
    let data = confirmEditData.data;
    let newData = confirmEditData.newData;
    let isSame:boolean = this.deepCompare(data,newData);
    return isSame
  }

  deepCompare(obj1: any,
    obj2: any,
    compareOrder: boolean = false):boolean{
      if (typeof obj1 !== typeof obj2) return false;
    if ((typeof obj1 === "string" || typeof obj1 === "number") && obj1 !== obj2) return false;
    delete obj1.checkbox;
    if(obj1.hasOwnProperty("parameterMaps")){
      delete obj1.parameterMaps;
    }
    
    const o1 = Object.entries(obj1);
    delete obj2.checkbox;
    if(obj2.hasOwnProperty("parameterMaps")){
      delete obj2.parameterMaps;
    }
    const o2 = Object.entries(obj2);

    const compare = (first: [string, unknown][], second: [string, unknown][]) => {
        return first.every((value, index): boolean => {
            const secondIndex = second.findIndex(val => val[0] === value[0])
            if ((compareOrder && index !== secondIndex) || secondIndex === -1) return false;
            const [k1, v1] = value
            const [k2, v2] = second[secondIndex]
            if (k1 !== k2) return false;
            //if (typeof v1 === "object" || typeof v2 === "object") return this.deepCompare(v1, v2);
            if (v1 != v2) return false
           return true;
        })
    }
    return compare(o1, o2)

  }


}
export interface ConfirmEditInfo{
  confirmEditData?:{data:any,newData:any};
  rowIndex?:number;

}
